import React from 'react';

function Footer() {
    return (
        <div>
            <section className="ftr-sec">
                <footer className="footer">
                    <nav className="ftr_lst_wrp">
                        <ul className="ftr_list1">
                            <li>Connect with Waters</li>
                            <li><a href="https://www.facebook.com/Waters" target="_blank"><img src="/BioAdvisor/images/Facebook.png" /></a></li>
                            <li><a href="https://twitter.com/@WatersCorp" target="_blank"><img src="/BioAdvisor/images/Twitter.png" /></a></li>
                            <li><a href="http://www.linkedin.com/companies/waters" target="_blank"><img src="/BioAdvisor/images/LinkedIn.png" /></a></li>
                            <li><a href="http://www.youtube.com/user/WatersCorporation" target="_blank"><img src="/BioAdvisor/images/Youtube.png" /></a></li>
                        </ul>
                    </nav>

                    <hr />  

                    <nav className="ftr_lst_wrp">
                    <ul className="ftr_list2">
                        <li><a href="http://www.waters.com/waters/en_US/Global-Privacy-Policy/nav.htm?cid=1000241" target="_blank">PRIVACY</a></li>
                        <li><a href="http://www.waters.com/waters/en_US/Terms-of-Use/nav.htm?cid=1000245" target="_blank">TERMS OF USE</a></li>
                        <li><a href="http://www.waters.com/waters/en_US/Trademarks/nav.htm?cid=1000238" target="_blank">TRADEMARKS</a></li>
                        <li><a href="http://www.waters.com/waters/sitemap.htm" target="_blank">SITEMAP</a></li>
                        <li><a href="http://www.waters.com/waters/en_US/Global-Job-Opportunities/nav.htm?cid=134690899" target="_blank">CAREERS</a></li>
                        <li className="contactUs"><a href="https://www.waters.com/waters/form.htm?id=135083621" target="_blank">REQUEST INFORMATION</a></li>
                    </ul>
                    <p>© 2021 Waters Corporation</p>    
                    </nav>    
                </footer>
            </section>
        </div>
    );
}

export default Footer;